/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const event_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "number",
        defaultDisplayPreferences: {
            order: 0,
            size: 80,
            visible: true,
            displayAs: "string",
            pinned: true,
        },
    },
    {
        id: "date",
        defaultDisplayPreferences: {
            order: 1,
            size: 230,
            visible: true,
            displayAs: "date",
            pinned: false,
        },
    },
    {
        id: "duration",
        defaultDisplayPreferences: {
            order: 2,
            size: 100,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "attendances",
        defaultDisplayPreferences: {
            order: 3,
            size: 250,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "title",
        defaultDisplayPreferences: {
            order: 4,
            size: 200,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "description",
        defaultDisplayPreferences: {
            order: 5,
            size: 200,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "type",
        defaultDisplayPreferences: {
            order: 6,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "promotions_units",
        defaultDisplayPreferences: {
            order: 7,
            size: 250,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "faculties",
        defaultDisplayPreferences: {
            order: 8,
            size: 150,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "createdAt",
        defaultDisplayPreferences: {
            order: 9,
            size: 120,
            visible: true,
            displayAs: "date",
            pinned: false,
        },
    },
    {
        id: "author",
        defaultDisplayPreferences: {
            order: 10,
            size: 200,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
];
